module.exports = __webpack_public_path__ + "img/AppleStore.490f0da9.png";